import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: '400px',
    maxWidth: '400px',
    borderRadius: '8px',
    // Se o seu tema tiver a scrollbar, pode descomentar:
    // ...theme.scrollbarStylesSoft
  },
  dialogTitle: {
    padding: '24px 24px 0 24px !important', 
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      color: theme.palette.red_100.main // Mantém a cor de alerta padrão
    }
  },
  titleText: {
    fontSize: '1.6rem',
    fontWeight: '600',
    color: theme.palette.red_100.main
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: 'none !important',
    padding: theme.spacing(2),
  },
  textMessage: {
    fontWeight: '400',
    textAlign: 'center', // Para o aviso ficar elegante
    color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
  },
  dialogActions: {
    padding: '16px 24px',
    justifyContent: 'center' // Centraliza o botão de OK
  }
}))